let breadcrumbs = {
    computed: {
        $iBreadcrumbs() {
            return {
                setText: (text) => {
                    this.$route.meta.breadcrumb.text = text;
                },
                setParentText: (text) => {
                    let route = this.$router.options.routes.find((route) => {
                        return route.path === this.$route.meta.breadcrumb.parent;
                    });

                    route.meta.breadcrumb.text = text;
                }
            }
        }
    }
};

export default breadcrumbs;
